

































































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
  Mutation,
} from 'vuex-class';
import Table from '@/components/Table.vue';
import DataSetService from '@/services/dataset.service';
import { DataSet, DataSetRule, PublishingIntegrationConfiguration, Integration, IntegrationOutputType, StreamingIntegrationConfiguration } from '@/types';
import IntegrationsService from '@/services/integrations.service';
import IntegrationIcon from '@/components/IntegrationIcon.vue';
import DataSetDataDialog from '@/views/publish/DataSetDataDialog.vue';
import { copyToClipboard } from '@/classes/utils';
import Badge from '@/components/Badge.vue';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
    Table,
    IntegrationIcon,
    DataSetDataDialog,
    Badge,
  },
})
export default class DataSets extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId!: number;
  @Action private addToastErrorMessage: any;

  private readonly severityOptions: Array<{ text: string, value: number }> = [
    {text: 'info', value: 1},
    {text: 'warning', value: 3},
    {text: 'critical', value: 5},
  ];

  private bus: any = new Vue();

  private datasets: DataSet[] = [];
  private currentDataset: DataSet = {name: '', filters: '', streaming: false, query: false, owner: '', publishing: false };
  private selectedDataset: DataSet = {name: '', filters: '', streaming: false, query: false, owner: '', publishing: false }; // TODO: Unnecessary variable
  private fixedHeader: boolean = false;
  private paginationOptions: number[] = [];
  private perPage = 100;

  private loading: boolean = true;
  private snackbar: boolean = false;
  private disableSave: boolean = true;
  private isValid: boolean = true;
  private showNoIntegrationMessage: boolean = false;

  private selectedIntegrations: {[key: number]: Array<Partial<StreamingIntegrationConfiguration>>} = {};
  private selectedExportIntegrations: {[key: number]: Array<Partial<PublishingIntegrationConfiguration>>} = {};
  private notificationIntegrations: any[] = [];
  private exportIntegrations: any[] = [];
  private integrationCounts: any = {};
  private integrationsTab: number = 0;
  private bacnetSelected: boolean = false;
  private emailSelected: boolean = false;

  private showModalConfirm: boolean = false;
  private preventConfirm: boolean = false;
  private modalHeader: string = '';
  private handleModalConfirm: any = null;
  private rules: DataSetRule[] = [];
  private integrations: Integration[] = [];
  private editingIntegrationIndex: number = -1;
  private expandedRows: DataSet[] = [];

  private tableData: any = {
    headers: [
      {text: 'Name', value: 'name', align: 'start', filterable: true},
      {text: 'Enable Streaming', value: 'streaming', sortable: false, filterable: false},
      {text: 'Enable Queries', value: 'query', sortable: false, filterable: false},
      {text: 'Created by', value: 'owner'},
      {text: '', value: 'actions', align: 'end'},
    ],
    total: 0,
    filters: {},
    distinctRows: {},
  };

  private types: any[] = [
    {title: 'webhook', icon: 'mdi-webhook'},
    {title: 'slack', icon: 'mdi-slack'},
    {title: 'mqtt', icon: 'mdi-aws'},
  ];

  private showDataDialog: boolean = false;
  private dataUuid: string = '';

  private copyToClipboard: (text: string) => boolean = copyToClipboard;

  private async mounted() {
    this.$route.params.snackbar ? this.snackbar = true : this.snackbar = false;

    const integrations = await IntegrationsService.getIntegrations();
    Vue.set(this, 'notificationIntegrations', integrations.filter((integration: Integration) => integration.output_type === IntegrationOutputType.STREAMING));
    Vue.set(this, 'exportIntegrations', integrations.filter((integration: Integration) => integration.output_type === IntegrationOutputType.PUBLISHING));


    Vue.set(this.tableData, 'headers', [
      ...this.tableData.headers.slice(0, 2),
      {text: 'Enable Publishing', value: 'publishing', sortable: false, filterable: false},
      ...this.tableData.headers.slice(2),
    ]);


    for (const integration of [...this.notificationIntegrations, ...this.exportIntegrations]) {
      const type = this.types.find((t: any) => t.title === integration.type);
      if (type) {
        integration.icon = type.icon;
      } else {
        integration.icon = '';
      }
    }

    this.getDataSets();
  }

  private getAvailableIntegrations(config: any, parentItem: any) {
    return this.notificationIntegrations.filter((i) => {
      const isCurrentSelection = i.id === config.integration_id;
      const isAlreadyUsed = this.selectedIntegrations[parentItem.id].some((c) => c.integration_id === i.id);

      return !isAlreadyUsed || isCurrentSelection;
    });
  }

  private showResultset(uuid: string) {
    this.dataUuid = uuid;
    this.showDataDialog = true;
  }

  private async getDataSets() {
    this.datasets = await DataSetService.getDataSets();

    await this.populateDataSets();
    await this.getCounts();
  }

  private async getCounts() {
    const datasetIds = this.tableData.rows.map((row: any) => row.id);

    if (datasetIds && datasetIds.length) {
      const counts = await DataSetService.getIntegrationCountsForDataset(datasetIds);
      Vue.set(this, 'integrationCounts', counts);
    }
  }

  private populateDataSets() {
    return new Promise((resolve, reject) => {
      const rows: any[] = [];
      this.datasets.forEach(async (row: any) => {
        rows.push({
          id: row.id,
          name: row.name,
          filters: row.filters,
          streaming: row.streaming,
          publishing: row.publishing,
          query: row.query,
          owner: row.owner,
          path: 'dataset/manage/' + row.id,
          isSystem: row.owner === 'system',
          uuid: row.uuid,
        });
      });
      Vue.set(this.tableData, 'rows', rows);
      this.loading = false;
      this.tableData ?
        resolve(this.tableData) :
        reject(this.addToastErrorMessage('Error resolving table data.'));
    });
  }

  private goTo(row: any) {
    if (row.path) {
      this.$router.push({ path: row.path });
    }
  }

  private async updateDataSet(row: any) {
    const payload: DataSet = {
      id: row.id,
      name: row.name,
      filters: row.filters,
      streaming: row.streaming,
      publishing: row.publishing,
      query: row.query,
      owner: row.owner,
    };

    await DataSetService.updateDataSet(row.id, payload);
    await this.getIntegrationsForDataset(row.id);
  }

  private editIntegration(index: number) {
    this.editingIntegrationIndex = index;
  }

  private setExpanded(rows: any) {
    this.editingIntegrationIndex = -1;
    Vue.set(this, 'expandedRows', rows);
  }

  private customSort(items: any[], index: string, isDesc: boolean) {
    return [
      ...items.filter(({owner}) => owner === 'system'),
      ...items.filter(({owner}) => owner !== 'system'),
    ];
  }

  private async getIntegrationsForDataset(id: number) {
    this.loading = true;

    const integrationsForDataset = await DataSetService.getStreamingIntegrationsForDataset(id);
    integrationsForDataset.forEach((config: any) => { config.had_info_severity = config.alerts_severity === 1; });
    const exportIntegrationsForDataset = await DataSetService.getPublishingIntegrationsForDataset(id);
    Vue.set(this.selectedIntegrations, id, integrationsForDataset);
    Vue.set(this.selectedExportIntegrations, id, exportIntegrationsForDataset);

    this.loading = false;
  }

  private applyIntegration(id: number) {
    const integration: object = this.integrationsTab === 0 ? {
      id: null,
      alerts_severity: this.severityOptions[0].value,
      alerts: false,
      alerts_suppress_repeats: true,
      alerts_cleared: false,
      dataset_updates: true,
    } : { id: null, lag_minutes: 0, period: '1 hour' };
    this.editingIntegrationIndex = (this.integrationsTab === 0 ? this.selectedIntegrations[id] : this.selectedExportIntegrations[id]).push(integration) - 1;
    this.bacnetSelected = false;
  }

  private async saveIntegration(integrationConfig: StreamingIntegrationConfiguration | PublishingIntegrationConfiguration) {
    if (!this.expandedRows || this.expandedRows.length === 0) {
      return;
    }

    const [selectedDataset] = this.expandedRows;
    if (!selectedDataset.id) {
      return;
    }

    this.loading = true;
    try {

      if (this.integrationsTab === 0) {
        const config = integrationConfig as StreamingIntegrationConfiguration;
        const body = {
          integration_id: config.integration_id,
          alerts_severity: config.alerts_severity,
          alerts_suppress_repeats: config.alerts_suppress_repeats,
          alerts: config.alerts,
          alerts_cleared: config.alerts_cleared,
          dataset_updates: config.dataset_updates,
          include_location_references: config.include_location_references,
          include_location_attributes: config.include_location_attributes,
          include_site_references: config.include_site_references,
          include_site_attributes: config.include_site_attributes,
        };
        if (integrationConfig.id) {
          await DataSetService.updateStreamingIntegrationForDataset(selectedDataset.id, integrationConfig.integration_id, body);
        } else {
          await DataSetService.createStreamingIntegrationForDataset(selectedDataset.id, body);
        }
      } else if (this.integrationsTab === 1) {
        const config = integrationConfig as PublishingIntegrationConfiguration;
        const body = {
          integration_id: config.integration_id,
          period: config.period,
          lag_minutes: config.lag_minutes,
          include_location_references: config.include_location_references,
          include_location_attributes: config.include_location_attributes,
          include_site_references: config.include_site_references,
          include_site_attributes: config.include_site_attributes,
        };

        if (integrationConfig.id) {
          await DataSetService.updatePublishingIntegrationForDataset(selectedDataset.id, integrationConfig.integration_id, body);
        } else {
          await DataSetService.createPublishingIntegrationForDataset(selectedDataset.id, body);
        }
      }

      this.editingIntegrationIndex = -1;

      await this.getIntegrationsForDataset(selectedDataset.id);
      await this.getCounts();
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  private async deleteIntegration(datasetId: number, integration: StreamingIntegrationConfiguration | PublishingIntegrationConfiguration) {
    if (integration.id) {
      await DataSetService.deleteIntegrationForDataset(datasetId, integration.integration_id);
      await this.getIntegrationsForDataset(datasetId);
      await this.getCounts();
    } else {
      const filtered = (this.integrationsTab === 0 ? this.selectedIntegrations[datasetId] : this.selectedExportIntegrations[datasetId] as Array<Partial<StreamingIntegrationConfiguration | PublishingIntegrationConfiguration>>).filter(( i: Partial<StreamingIntegrationConfiguration | PublishingIntegrationConfiguration>) => i.id !== integration.id);
      Vue.set(this.integrationsTab === 0 ? this.selectedIntegrations : this.selectedExportIntegrations, datasetId, filtered);
      ((this.integrationsTab === 0 ? this.$refs.form : this.$refs.exportIntegrationsForm) as Vue & { validate: () => boolean }).validate();
    }
  }

  private get integrationRules() {
    const rules: any[] = [];

    rules.push(
      (v: string) => {
        if (this.selectedIntegrations[Number(this.currentDataset.id)]) {
          if (this.selectedIntegrations[Number(this.currentDataset.id)].filter((s: Partial<StreamingIntegrationConfiguration>) => s.integration && s.integration.name === v).length > 1) {
            this.disableSave = true;
            return `Integration "${v}" already in use.`;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      (v: string) => {
        if (!this.isValid) {
          this.disableSave = true;
          return true;
        } else {
          this.disableSave = false;
          return true;
        }
      });
    return rules;
  }

  private getSeverityOptions(integrationConfig: Partial<StreamingIntegrationConfiguration>): Array<{ text: string, value: number, disabled?: boolean }> {
    const integration = this.notificationIntegrations.find((i) => i.id === integrationConfig.integration_id);
    if (!integration || integration.type !== 'email') {
      return this.severityOptions;
    }
    const options: Array<{ text: string, value: number, disabled?: boolean }> = this.severityOptions.filter((o) => o.value !== 1);
    if (integrationConfig.had_info_severity) {
      options.unshift({ text: 'info', value: 1, disabled: true });
    }
    return options;
  }

  private onIntegrationSelected(integrationConfig: Partial<StreamingIntegrationConfiguration>) {
    const integration = this.notificationIntegrations.find((i) => i.id === integrationConfig.integration_id);
    if (integration && integration.type === 'email' && integrationConfig.alerts_severity === 1) {
      const supported = this.severityOptions.find((o) => o.value !== 1);
      Vue.set(integrationConfig, 'alerts_severity', supported ? supported.value : integrationConfig.alerts_severity);
    }
    this.isBacnet(integration, integrationConfig);
    this.isEmail(integration, integrationConfig);
  }

  private isEmail(integration: Integration, integrationConfig: Partial<StreamingIntegrationConfiguration>) {
    this.emailSelected = integration.type === 'email';
    if (this.emailSelected) {
      Vue.set(integrationConfig, 'dataset_updates', false);
    }
  }

  private isBacnet(integration: Integration, integrationConfig: Partial<StreamingIntegrationConfiguration>) {
    this.bacnetSelected = integration.type === 'bacnet';
    if (this.bacnetSelected) {
      Vue.set(integrationConfig, 'include_location_references', true);
      Vue.set(integrationConfig, 'include_location_attributes', true);
      Vue.set(integrationConfig, 'dataset_updates', true);
      Vue.set(integrationConfig, 'alerts', false);
      Vue.set(integrationConfig, 'alerts_severity', this.severityOptions[0].value);
      Vue.set(integrationConfig, 'alerts_suppress_repeats', false);
      Vue.set(integrationConfig, 'alerts_cleared', false);
      Vue.set(integrationConfig, 'include_site_references', false);
      Vue.set(integrationConfig, 'include_site_attributes', false);
    }
  }

  private get editedIntegration(): Partial<StreamingIntegrationConfiguration> | Partial<PublishingIntegrationConfiguration> | null {
    if (!this.expandedRows || this.expandedRows.length === 0 || this.editingIntegrationIndex === -1) {
      return null;
    }

    const [selected] = this.expandedRows;
    if (!selected || !selected.id) {
      return null;
    }

    const source = this.integrationsTab === 0 ? this.selectedIntegrations[selected.id] : this.selectedExportIntegrations[selected.id];
    return source[this.editingIntegrationIndex] || null;
  }

  private showPublishingPlaceholder(datasetId: number) {
    if (this.exportIntegrations.length) {
      this.showNoIntegrationMessage = false;
      if (typeof this.selectedExportIntegrations[datasetId] !== 'undefined') {
        return this.selectedExportIntegrations[datasetId].length !== this.exportIntegrations.length;
      } else {
        return true;
      }
    } else {
      this.showNoIntegrationMessage = true;
    }
  }

  private showStreamingPlaceholder(datasetId: number) {
    if (this.notificationIntegrations.length) {
      this.showNoIntegrationMessage = false;
      if (typeof this.selectedIntegrations[datasetId] !== 'undefined') {
        return this.selectedIntegrations[datasetId].length !== this.notificationIntegrations.length;
      } else {
        return true;
      }
    } else {
      this.showNoIntegrationMessage = true;
    }
  }

  private async removeDataset( dataset: DataSet ) {

    this.rules = await DataSetService.getDatasetRules(Number(dataset.id));

    this.integrations = await DataSetService.getStreamingIntegrationsForDataset(Number(dataset.id));

    this.modalHeader = 'Remove selected dataset?';
    this.preventConfirm = true;

    if (!this.rules.length && !this.integrations.length) {
      this.preventConfirm = false;
    }

    this.handleModalConfirm = async () => {
      this.showModalConfirm = false;

      await this.deleteUnusedDataset( dataset );
      return;
    };

    this.showModalConfirm = true;
  }

  private async deleteUnusedDataset( selected: DataSet ) {
    if ( selected.id ) {
      await DataSetService.deleteDataSet(selected.id);
      this.getDataSets();
    } else {
      this.datasets = this.datasets.filter((dataset: DataSet) => dataset.name !== selected.name);
    }
  }

  private doModalConfirm() {
    return (this.handleModalConfirm === null) ? false : this.handleModalConfirm();
  }

  private async deleteRules(datasetId: number) {
    if (datasetId) {
      await DataSetService.deleteAllRulesForDataset(Number(datasetId));
      Vue.set(this, 'rules', []);
      if (this.rules.length === 0 && this.integrations.length === 0) {
        this.preventConfirm = false;
      }
    }
  }

  private async deleteIntegrations(datasetId: number) {
    if (datasetId) {
      await DataSetService.deleteAllIntegrationsForDataset(Number(datasetId));
      this.integrations = [];
      if (this.rules.length === 0 && this.integrations.length === 0) {
        this.preventConfirm = false;
      }
    }
  }

  private closeModal() {
    this.showModalConfirm = false;
    if (!this.integrations.length) {
      Vue.set(this.selectedIntegrations, Number(this.selectedDataset.id), []);
    }
    this.getCounts();
  }

  private get addingIntegration(): boolean {
    return !!this.editedIntegration && !this.editedIntegration.id;
  }

  private get showIntegrationSave(): boolean {
    if (!this.editedIntegration) {
      return false;
    }

    if (this.integrationsTab === 0) {
      const config = this.editedIntegration as StreamingIntegrationConfiguration;
      return !!config.integration_id && (!!config.alerts || !!config.dataset_updates || !!config.alerts_cleared);
    }

    const integrationConfig = this.editedIntegration as PublishingIntegrationConfiguration;
    return !!integrationConfig.integration_id;
  }

  @Watch('integrationsTab')
  private handleTabChange(value: number) {
    this.editingIntegrationIndex = -1;
  }
}
